import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, CanActivateChild } from '@angular/router';
import { take, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserService } from '@nrwl/rx-service-user';
import { AuthService } from '@nrwl/rx-service-auth';
import { Roles } from '@nrwl/rx-models';

@Injectable()
export class PermissionLocationsGuard implements CanActivate, CanLoad, CanActivateChild {
  constructor(
    private _userService: UserService,
    private _authService: AuthService,
  ) {}

  public canActivate(state): boolean | Observable<boolean> {
    return this._checkPermission(state);
  }

  public canLoad(state): boolean | Observable<boolean> {
    return this._checkPermission(state);
  }

  public canActivateChild(state): boolean | Observable<boolean> {
    return this._checkPermission(state);
  }

  private _checkPermission(state): boolean | Observable<boolean> {
    const userId = this._authService.getUserId;
    return this._userService.getUserProfile(userId).pipe(
      map((response: any) => {
        if (response.role === Roles.SuperAdmin || response.role === Roles.Admin) {
          return true;
        } else {
          return false;
        }
      }),
      take(1),
    );
  }
}
